import { useSearchParams } from "react-router-dom";
import { BackgroundBlur, LoginHeader, HeroSection } from "../components/login";
import ResetPasswordForm from "../components/login/ui/ChangePasswordForm.jsx";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  return (
    <div className="flex h-full w-full bg-white dark:bg-slate-900 overflow-hidden">

      {/* LEFT */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-6 sm:p-12 relative bg-[#f4f6f8] dark:bg-slate-900">
        <BackgroundBlur />
        <div className="w-full max-w-md relative z-10">
          <LoginHeader title="Reset Password" />
          <div className="bg-white dark:bg-slate-800/80 p-8 rounded-[2rem] shadow-xl border border-slate-100 dark:border-slate-700/50 backdrop-blur-xl">
            <ResetPasswordForm token={token} />
          </div>
        </div>
      </div>

      {/* RIGHT */}
      <HeroSection />

    </div>
  );
}